module.exports = __webpack_public_path__ + "static/media/PierA.f89bf183.png";